import { FileEdit, FileText, Layers, MessageSquare, Search, ShieldAlert, Sparkles } from "lucide-react";

export interface AgentCatalogItem {
  id: string;
  path: string;
  name: string;
  description: string;
  gradient: string;
  icon: any;
}

export const AGENT_CATALOG: Record<string, AgentCatalogItem> = {
  // "legal-chatbot-v2": {
  //   id: "legal-chatbot-v2",
  //   path: "/dashboard/agents/legal-chatbot-v2",
  //   name: "Chatbot Legal RAG (V2)",
  //   description: "Consultas RAG ultra-rápidas directamente vinculadas a la KB.",
  //   icon: Sparkles,
  //   gradient: "from-indigo-500 to-cyan-600",
  // },
  "campus-consultorio": {
    id: "campus-consultorio",
    path: "/dashboard/campus-consultorio",
    icon: "GraduationCap",
    name: "Campus & Consultorio Jurídico",
    description: "Taller socrático, control Ley 2113 de 2021 y auditoría de citas.",
  },
  "legal-chatbot": {
    id: "legal-chatbot",
    path: "/dashboard/agents/legal-chatbot",
    name: "Chatbot Legal",
    description: "Consultas instantaneas y evaluacion de casos.",
    icon: MessageSquare,
    gradient: "from-purple-500 to-violet-600",
  },
  "document-generator": {
    id: "document-generator",
    path: "/dashboard/agents/document-generator",
    name: "Redaccion de Documentos",
    description: "Generacion automatizada de documentos legales.",
    icon: FileEdit,
    gradient: "from-emerald-500 to-teal-600",
  },
  "document-drafting-v2": {
    id: "document-drafting-v2",
    path: "/dashboard/agents/document-drafting-v2",
    name: "Redactor de Documentos V2",
    description: "Generacion inteligente con IA - Wizard + Vista previa.",
    icon: Sparkles,
    gradient: "from-violet-500 to-purple-600",
  },
  "legal-research": {
    id: "legal-research",
    path: "/dashboard/agents/legal-research-v2",
    name: "Investigacion Legal",
    description: "Investigacion NLP v2 - Wizard + Inteligencia.",
    icon: Search,
    gradient: "from-blue-500 to-indigo-600",
  },
  "contract-review": {
    id: "contract-review",
    path: "/dashboard/agents/contract-review-v2",
    name: "Revision de Contratos",
    description: "Analisis premium v2 - Riesgos + Obligaciones.",
    icon: FileText,
    gradient: "from-red-500 to-rose-600",
  },
  "debt-collection": {
    id: "debt-collection",
    path: "/dashboard/agents/legal-notifications",
    name: "Recoleccion de Deudas",
    description: "Recuperación de cartera y cobro prejurídico PH (Ley 675 de 2001).",
    icon: FileText,
    gradient: "from-amber-500 to-orange-600",
  },
  "consumer-assistant": {
    id: "consumer-assistant",
    path: "/dashboard/agents/consumer-assistant",
    name: "Asistente de Consumidor",
    description: "Asistencia en reclamaciones de consumidor.",
    icon: FileText,
    gradient: "from-pink-500 to-rose-600",
  },
  "ip-assistant": {
    id: "ip-assistant",
    path: "/dashboard/agents/ip-assistant",
    name: "Asistente de Patentes V2",
    description: "Analisis premium v2 - Patentes + Prior Art.",
    icon: FileText,
    gradient: "from-indigo-500 to-blue-600",
  },
  "litigation-predictor": {
    id: "litigation-predictor",
    path: "/dashboard/agents/case-prediction-v2",
    name: "Prediccion de Litigios",
    description: "Prediccion premium v2 - Probabilidades + Estrategia.",
    icon: FileText,
    gradient: "from-teal-500 to-cyan-600",
  },
  "compliance-monitor": {
    id: "compliance-monitor",
    path: "/dashboard/agents/compliance-monitoring",
    name: "Monitoreo de Cumplimiento V2",
    description: "Monitoreo premium v2 - Auditoria + Riesgos.",
    icon: FileText,
    gradient: "from-orange-500 to-red-600",
  },
  "whistleblower": {
    id: "whistleblower",
    path: "/dashboard/agents/whistleblower",
    name: "Proteccion al Denunciante",
    description: "Analisis premium v2 - Etica + Proteccion.",
    icon: ShieldAlert,
    gradient: "from-slate-600 to-gray-800",
  },
  "contract-review-v2": {
    id: "contract-review-v2",
    path: "/dashboard/agents/contract-review-v2",
    name: "Revision de Contratos V2",
    description: "Analisis premium v2 - Riesgos + Obligaciones.",
    icon: FileText,
    gradient: "from-red-600 to-rose-700",
  },
  "legal-research-v2": {
    id: "legal-research-v2",
    path: "/dashboard/agents/legal-research-v2",
    name: "Investigacion Legal V2",
    description: "Investigacion NLP v2 - Wizard + Inteligencia.",
    icon: Search,
    gradient: "from-blue-600 to-indigo-700",
  },
  "case-prediction-v2": {
    id: "case-prediction-v2",
    path: "/dashboard/agents/case-prediction-v2",
    name: "Prediccion de Litigios V2",
    description: "Prediccion premium v2 - Probabilidades + Estrategia.",
    icon: FileText,
    gradient: "from-teal-600 to-cyan-700",
  },
  "compliance-monitor-v2": {
    id: "compliance-monitor-v2",
    path: "/dashboard/agents/compliance-monitoring",
    name: "Monitoreo de Cumplimiento V2",
    description: "Monitoreo premium v2 - Auditoria + Riesgos.",
    icon: FileText,
    gradient: "from-orange-600 to-red-700",
  },
  "ip-assistant-v2": {
    id: "ip-assistant-v2",
    path: "/dashboard/agents/ip-assistant",
    name: "Asistente de Patentes V2",
    description: "Analisis premium v2 - Patentes + Prior Art.",
    icon: FileText,
    gradient: "from-indigo-600 to-blue-700",
  },
  "whistleblower-v2": {
    id: "whistleblower-v2",
    path: "/dashboard/agents/whistleblower",
    name: "Proteccion al Denunciante V2",
    description: "Analisis premium v2 - Etica + Proteccion.",
    icon: ShieldAlert,
    gradient: "from-slate-700 to-gray-900",
  },
  specialized: {
    id: "specialized",
    path: "/dashboard/agents/specialized",
    name: "Agentes Especializados",
    description: "Acceso a 23+ expertos legales especializados por sector.",
    icon: Layers,
    gradient: "from-blue-700 to-indigo-800",
  },
};

export const MOBILE_ENABLED_AGENT_IDS = new Set([
  "specialized",
  "document-drafting-v2",
  "document-generator",
  "contract-review-v2",
  "contract-review",
  "legal-research-v2",
  "legal-research",
  "case-prediction-v2",
  "litigation-predictor",
  "debt-collection",
]);
